// extracted by mini-css-extract-plugin
export default {"button":"NextButton_button__sZNpy"};